export const statusOptions = [
  'claimed',
  'new',
  'verifying',
  'verified',
  'canceled',
  'rejected',
];

export const activeStatusVals = [
  'claimed',
  'new',
  'verifying',
];

export const statusColors = {
  claimed: 'yellow',
  new: 'platinum',
  verifying: 'blue',
  verified: 'green',
  canceled: 'brown',
  rejected: 'red',
};
